var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5C6.48125 3.5 5.25 4.73125 5.25 6.25C5.25 7.76875 6.48125 9 8 9C9.51875 9 10.75 7.76875 10.75 6.25C10.75 4.73125 9.51875 3.5 8 3.5ZM8 7.5C7.31063 7.5 6.75 6.93906 6.75 6.25C6.75 5.55937 7.30937 5 8 5C8.69063 5 9.25 5.56063 9.25 6.25C9.25 6.94063 8.69063 7.5 8 7.5ZM8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM8 14.5C6.53969 14.5 5.195 14.01 4.10938 13.1941C4.65 12.1562 5.7 11.5 6.88125 11.5H9.12156C10.3013 11.5 11.35 12.1566 11.8928 13.1941C10.8063 14.0094 9.45938 14.5 8 14.5ZM13.0063 12.1406C12.1625 10.8219 10.725 10 9.11875 10H6.88125C5.27625 10 3.83906 10.8203 2.99375 12.14C2.06125 11.0156 1.5 9.57187 1.5 8C1.5 4.41563 4.41594 1.5 8 1.5C11.5841 1.5 14.5 4.41594 14.5 8C14.5 9.57187 13.9375 11.0156 13.0063 12.1406Z",
    fill: "#1E8B7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSettingIcon);
export default __webpack_public_path__ + "static/media/user-setting-icon.09d81dc1.svg";
export { ForwardRef as ReactComponent };